export enum KeyEnum {
  SidebarSearch = 'sidebar-search',
  LobbyGame = 'lobby-game',
  AllGames = 'all-games',
  HomeLiveCasino = 'home-live-casino',
  HomeLivestreamLiveCasino = 'home-livestream-live-casino',
  GameCard = 'game-card-section-games',
  PopularGame = 'popular-section-games',
  GameEvent = 'game-event-section-games',
  TopWinnerGame = 'top-winner-game-data',
  JackpotGame = 'jackpot-section-games',
  TopWinning = 'home-top-winner'
}
